// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import styled from 'styled-components';

export const HeaderWrapper = styled.header``;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 72px;

  svg {
    height: 24px;
    width: 48px;
  }

  @media only screen and (min-width: 426px) {
    height: 98px;

    svg {
      height: 38px;
      width: 76px;
    }
  }
`;
